import { useState, useEffect, useRef } from "react"
import { GlobalScenarioAPIService } from "../../../services/apis/GlobalScenarioAPIService";
import { CommonAPIService } from "../../../services/apis/CommonAPIService";
import { ScenarioAPIService } from "../../../services/apis/ScenarioAPIService";
import { NodeAPIService } from "../../../services/apis/NodeAPIService";
import { TokenService } from "../../../services/TokenService";
import '../../../css/administration.css'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import Button from 'react-bootstrap/Button'
import BasicCard from "../../../components/basics/cards/BasicCard";
import AlertMessage from "../../../components/AlertMessage";

function ManageGlobalScenario() {    

    const [scenarios, setScenarios] = useState([]);
    const [mappingTypes, setMappingTypes] = useState([]);
    const [mappingTypeId, setMappingTypeId] = useState(-1);
    const [nodeId, setNodeId] = useState(-1);
    const [scenarioId, setScenarioId] = useState(-1);
    const [coupledNodes, setCoupledNodes] = useState([]);
    const [nodes, setNodes] = useState([]);    
    const [alertObject, setAlertObject] = useState({ variant: '', alertMessage: '' });
    const [validationError, setValidationError] = useState('');

    useEffect(() => {        
        CommonAPIService.getMappingTypes()
            .then(data => {
                setMappingTypes(data)
                setMappingTypeId(0);                
                if (data.length > 0) {
                    setMappingTypeId(data[0].mappingTypeId);
                    updateScenarios(data[0].mappingTypeId);
                    updateNodes(data[0].mappingTypeId);
                }

            })
    }, [])

    const updateScenarios = (mappingTypeId) => {
        ScenarioAPIService.getScenariosByScenarioTypeCodeAndMappingTypeId("GLOBAL", mappingTypeId).then(data => {
            setScenarios(data);
        });
    }

    const updateNodes = (mappingTypeId) => {
        const user = TokenService.getUser();
        if (user != null && user.account.username != null) {
            NodeAPIService.getNodesByEmailAndMappingTypeId(mappingTypeId).then(data => {
                if (data != 0)
                    setNodes(data);
                else
                    setValidationError(process.env.REACT_APP_USER_ERROR_MESSAGE);
            });
        }
    }

    const updateScenariosByMappingTypeId = (e) => {
        setAlertObject({ variant: '', alertMessage: '' });
        setMappingTypeId(e.target.value);
        setCoupledNodes([]);
        setNodes([]);

        if (e.target.value !== "" && e.target.value !== 0) {
            ScenarioAPIService.getScenariosByScenarioTypeCodeAndMappingTypeId("GLOBAL", e.target.value).then(data => {
                setScenarios(data);
                updateNodes(e.target.value);
            });
        }
    }

    const getNodesByScenarioId = (e) => {
        setAlertObject({ variant: '', alertMessage: '' });
        setScenarioId(e.target.value);
        setCoupledNodes([]);

        if (e.target.value !== "" && e.target.value !== 0) {
            ScenarioAPIService.getNodesByScenarioId(e.target.value).then(data => {
                setCoupledNodes(data);
            });
        }
    }

    const isNodeExistInCoupled = (nodeId) => {
        if (coupledNodes.some(node => node.nodeId == nodeId))
            return true;
        else
            return false;
    }

    const handleCancel = () => {
        if (document.getElementById("nodeId") !== undefined)
            document.getElementById("nodeId").value = 0;

        setCoupledNodes([]);
        setAlertObject({ variant: '', alertMessage: '' });
    }

    const moveNodes = (action) => {
        setAlertObject({ variant: '', alertMessage: '' });

        if (document.getElementById("nodes") !== undefined) {
            var currCoupledNodes = [];
            if (action == "right") {                
                for (var option of document.getElementById('coupledNodes').options) {
                    if (!option.selected) {
                        var node = { nodeCode: "", nodeId: option.value, nodeName: option.text };
                        currCoupledNodes.push(node);
                    }
                }
                console.log(currCoupledNodes); console.log(nodes);

                setCoupledNodes(currCoupledNodes);
                setNodes(nodes);
            }

            if (action == "moveAllRight")
                setCoupledNodes([]);


            if (action == "left" || action == "moveAllLeft") {                
                coupledNodes.map((coupledNode) => {
                    var node = { entityCode: coupledNode.nodeCode, nodeId: coupledNode.nodeId, nodeName: coupledNode.nodeName };
                    currCoupledNodes.push(node);
                });

                setCoupledNodes([]);

                for (var option of document.getElementById('nodes').options) {
                    if (option.selected || action == "moveAllLeft") {
                        if (!currCoupledNodes.some(node => node.nodeId === option.value)) {
                            var node = { nodeCode: "", nodeId: option.value, nodeName: option.text };
                            currCoupledNodes.push(node);
                        }
                    }
                }
                setCoupledNodes(currCoupledNodes);
                setNodes(nodes);
            }
        }
    }

    const handleSave = (e) => {
        e.preventDefault();
        setAlertObject({ variant: '', alertMessage: '' });

        if (document.getElementById("scenarioId") === undefined || document.getElementById("scenarioId") == null || document.getElementById("scenarioId").value === "0") {
            setAlertObject({ variant: 'danger', alertMessage: 'Please choose a scenario from the scenario list to couple the nodes!' })
            return false;
        }

        if (coupledNodes === undefined || coupledNodes.length == 0) {
            setAlertObject({ variant: 'danger', alertMessage: 'You cannot decouple all the nodes. Please select atleast one node!' })
            return false;
        }

        var scenarioNodes = {
            Id: scenarioId,
            Ids: coupledNodes.map(e => e.nodeId)
        };

        ScenarioAPIService.updateScenarioNodes(scenarioNodes).then(
            response => {
                setAlertObject({ variant: 'success', alertMessage: "Nodes are saved." });
            }
        );
    }

    const AddRemoveClass = {
        border: "1px solid #7f9db9",
    };
    return (
        <div style={{ width: '100%' }}>
            <BasicCard cardConfig={{ cardTitle: 'Couple scenario with node' }}>
                {validationError ? <p style={{ color: 'red' }}>{validationError}</p> : ""}
                {alertObject.alertMessage ? <AlertMessage alertObject={alertObject} setAlertObject={setAlertObject} /> : ""}
                <Container>
                    <Row>
                        <Col>
                            <label>Mapping type: &nbsp;</label>
                            <label><select id='mappingTypeId' name="mappingTypeId" onChange={updateScenariosByMappingTypeId} >
                                {/*<option value="0">--Select--</option>*/}
                                {mappingTypes?.length > 0 ?
                                    mappingTypes.map((mappingType) => <option value={mappingType.mappingTypeId} key={mappingType.mappingTypeId}>{mappingType.mappingTypeName}</option>)
                                    : null
                                }
                            </select>
                            </label>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <label>Scenario: &nbsp;</label>
                            <label><select id='scenarioId' name="scenarioId" onChange={getNodesByScenarioId} >
                                <option value="0">--Select--</option>
                                {scenarios?.length > 0 ?
                                    scenarios.map((scenario) => <option value={scenario.scenarioID} key={scenario.scenarioID}>{scenario.scenarioName}</option>)
                                    : null
                                }
                            </select>
                            </label>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            &nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Row>
                                <Col>
                                    <label>Coupled nodes</label>
                                </Col>
                            </Row>
                            <select
                                id='coupledNodes'
                                name='coupledNodes'
                                multiple
                                size='10'
                                label='Coupled nodes'
                                select-all="true"
                                select-all-text='Select all'
                                multiple-options-selected-text='{a} items selected'
                                className='select-tagetik-entity'
                                placeholder='--Select node(s)--'>
                                {coupledNodes?.length > 0 ?
                                    coupledNodes.map((coupledNode) => <option value={coupledNode.nodeId} key={coupledNode.nodeId}>{coupledNode.nodeName}</option>)
                                    : null
                                }
                            </select>
                        </Col>
                        <Col>
                            <span className='move-nodes'>
                                <Button style={AddRemoveClass} onClick={() => moveNodes("left")}>&#60;</Button>&nbsp;
                                <Button style={AddRemoveClass} onClick={() => moveNodes("right")}>&#62;</Button>&nbsp;
                                <Button style={AddRemoveClass} onClick={() => moveNodes("moveAllLeft")}>&#60;&#60;</Button>&nbsp;
                                <Button style={AddRemoveClass} onClick={() => moveNodes("moveAllRight")}>&#62;&#62;</Button>&nbsp;
                            </span>
                        </Col>
                        <Col>
                            <Row>
                                <Col>
                                    <label>Nodes</label>
                                </Col>
                            </Row>
                            <select
                                id='nodes'
                                multiple
                                size='10'
                                label='Nodes'
                                select-all="true"
                                select-all-text='Select all'
                                multiple-options-selected-text='{a} items selected'
                                className='select-tagetik-entity'
                                placeholder='--Select node/nodes--'>
                                {nodes?.length > 0 ?
                                    nodes.filter(filterEntity => !isNodeExistInCoupled(filterEntity.nodeId)).map((node) =>
                                        <option value={node.nodeId} key={node.nodeId}>{node.nodeName}</option>)
                                    : <option value="0">&nbsp;</option>
                                }
                            </select>
                        </Col>
                    </Row>
                </Container>
                <span className='cancel-save' style={{ marginTop: '1rem' }}>
                    <a href='#' onClick={handleCancel}>Cancel</a>
                    <Button variant='primary' className='node-admin-save' onClick={handleSave} style={{ marginLeft: '1rem' }}>Save</Button>
                </span>
            </BasicCard>
        </div>
    )
}

export default ManageGlobalScenario